/**
 * Encouragement banner shown at the top of the readiness checklist +
 * workbook. Reframes scoring as a positive, no-shame exercise: thinking
 * and planning is half the battle, and honest self-assessment builds
 * strength for future you.
 */
import React from "react";
import { Heart, Sprout, Compass } from "lucide-react";

const CARDS = [
  {
    icon: Heart,
    title: "Thinking is half the battle",
    body: "You&apos;re already ahead of most people the moment you open this page. There is no wrong answer here — only useful ones.",
  },
  {
    icon: Compass,
    title: "Every score is a map",
    body: "A low number today is not a grade — it&apos;s a compass. It tells Future You exactly where to point next.",
  },
  {
    icon: Sprout,
    title: "Honest checks build strength",
    body: "The honesty you bring here compounds. Ninety days from now you&apos;ll see the line move — and so will your confidence.",
  },
];

export default function EncouragementBanner() {
  return (
    <section
      data-testid="encouragement-banner"
      className="mt-8 rounded-2xl bg-gradient-to-br from-[#E8F0EB] via-[#F0EFEA] to-[#FDF2ED] border border-[#2B5339] p-5 sm:p-6 print:hidden"
    >
      <div className="text-[10px] tracking-[0.2em] uppercase font-semibold text-[#2B5339] mb-2">
        A note before you start
      </div>
      <p className="text-[#1C2B23] leading-relaxed text-lg">
        <strong>You&apos;re not being graded.</strong> You&apos;re building. Every honest check pays
        Future You back — with clarity, with confidence, and with time to make good decisions instead
        of rushed ones.
      </p>
      <div className="mt-5 grid sm:grid-cols-3 gap-3">
        {CARDS.map((c, i) => (
          <div key={i} className="flex items-start gap-2.5 bg-white/70 rounded-xl p-3">
            <c.icon size={16} className="text-[#2B5339] mt-0.5 flex-shrink-0" />
            <div>
              <div className="text-sm font-medium text-[#1C2B23]">{c.title}</div>
              <p
                className="text-xs text-[#5C6B62] mt-0.5 leading-relaxed"
                dangerouslySetInnerHTML={{ __html: c.body }}
              />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
